import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  RESET_NOT_FOUND,
  RESET_NETWORK_ERROR,
  SET_ACTIVE_PAGE,
  RESET_ACTIVE_PAGE,
  UPDATE_DEVICE,
  FETCH_CURRENCIES_SUCCESS,
  FETCH_CURRENCIES_ERROR,
  CLEAR_FETCH_CURRENCIES,
  CLEAR_ACTION_NOTIFICATION,
  SET_LAST_PATCHED_ID,
  RESET_LAST_PATCHED_ID,
} from 'redux/common/types';


export const resetNotFound = () => dispatch => {
  dispatch({
    type: RESET_NOT_FOUND,
  });
};

export const resetNetworkError = () => dispatch => {
  dispatch({
    type: RESET_NETWORK_ERROR,
  });
};

export const setActivePage = activePage => dispatch => {
  dispatch({
    type: SET_ACTIVE_PAGE,
    payload: activePage,
  });
};

export const resetActivePage = () => dispatch => {
  dispatch({
    type: RESET_ACTIVE_PAGE,
  });
};

export const updateDevice = deviceName => dispatch => {
  dispatch({
    type: UPDATE_DEVICE,
    payload: deviceName,
  });
};

export const fetchCurrencies = () => baseErrorsHandlerDecorator(
  FETCH_CURRENCIES_SUCCESS,
  FETCH_CURRENCIES_ERROR,
  () => restapi.get(addLang('users/currency/')),
  false,
);

export const clearFetchCurrencies = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_CURRENCIES,
  });
};

export const clearActionNotification = () => dispatch => {
  dispatch({
    type: CLEAR_ACTION_NOTIFICATION,
  });
};

export const setLastPatchedId = patchId => dispatch => {
  dispatch({
    type: SET_LAST_PATCHED_ID,
    payload: patchId,
  });
};

export const resetLastPatchedId = () => dispatch => {
  dispatch({
    type: RESET_LAST_PATCHED_ID,
  });
};
